<template>
    <div>
        <img
            class="scroll-bar"
            ref="scrollbar"
            src="../assets/images/home/scroll_bar.png"
            alt="scroll_bar"
            v-debounce="scroll"
        />
    </div>
</template>

<script>
export default {
    name: "scroll-bar",

    components: {},
    data: () => ({}),
    created() {},
    mounted() {},
    watch: {},
    computed: {
        NAV_ACTIVE_INDEX() {
            // 导航栏激活指数
            if (this.$store.state.HOME_FULLPAGE) {
                // 异步对象
                return this.$store.state.HOME_FULLPAGE.activeIndex;
            } else {
                return -1;
            }
        },
        HOME_FULLPAGE() {
            return this.$store.state.HOME_FULLPAGE;
        }
    },
    methods: {
        scroll() {
            let index = this.NAV_ACTIVE_INDEX + 1;
            this.HOME_FULLPAGE.goTo(index)
        }
    },
    directives: {
        debounce: {
            inserted: function(el, binding) {
                let wait = false;
                el.addEventListener("click", () => {
                    if(!wait) {
                        wait = true
                        binding.value();
                        setTimeout(() => {
                            wait = false
                        }, 1000)      
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.scroll-bar {
    position: absolute;
    z-index: 991;
    width: pxTorem(77.5px);
    bottom: pxTorem(20px);
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    transition: all .5s;
    animation: 6s idle infinite;

    @keyframes idle {
        0% {
            opacity: 0.3;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0.3;
        }
    }

    &:hover {
        width: pxTorem(155px);
        animation: none;
    }
}
</style>
